import React from 'react';
import { Box, Card, Typography } from '@mui/material';

interface FaqItem {
  question: string;
  answer?: string;
  expanded: boolean;
}

interface HelpSupportFaqCardProps {
  items: FaqItem[];
  onToggle: (index: number) => void;
}

export const HelpSupportFaqCard: React.FC<HelpSupportFaqCardProps> = ({ items, onToggle }) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: '20px',
        border: '1px solid rgba(0,0,0,0.05)',
        boxShadow: '0 4px 4px rgba(0,0,0,0.07)',
        px: '22px',
        pt: 3,
        pb: '10px',
      }}
    >
      <Typography sx={{ fontSize: 28, lineHeight: 1.15, fontWeight: 600, color: '#000' }}>Frequently Asked Questions</Typography>
      <Typography sx={{ mt: 1, fontSize: 14, color: '#6a7282' }}>
        Quick answers to help you understand and use the platform better
      </Typography>

      <Box sx={{ mt: 3 }}>
        {items.map((item, index) => (
          <Box
            key={item.question}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              py: 2,
              borderBottom: index !== items.length - 1 ? '1px solid #d1d5dc' : 'none',
            }}
          >
            <Box sx={{ pr: 2 }}>
              <Typography sx={{ fontSize: 14, lineHeight: '20px', fontWeight: 600, color: '#000' }}>{item.question}</Typography>
              {item.expanded ? (
                <Typography sx={{ mt: 0.5, fontSize: 12, color: '#6a7282' }}>{item.answer}</Typography>
              ) : null}
            </Box>
            <Box
              component="button"
              type="button"
              onClick={() => onToggle(index)}
              sx={{
                mt: '-1px',
                p: 0,
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                fontSize: 28,
                lineHeight: 1,
                color: '#27272a',
              }}
            >
              {item.expanded ? '−' : '+'}
            </Box>
          </Box>
        ))}
      </Box>
    </Card>
  );
};
